Bingo.DemandNotificationsTrigger = {};

Bingo.DemandNotificationsTrigger.init = () => {
    $('.js-demandBlock__notificationSwitch').on('click', 'a.A-dropdownMenu__item', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();

        const notificationsSwitch = $(this).closest('.js-demandBlock__notificationSwitch');

        $.nette.ajax({
            url: notificationsSwitch.data('notifications-change-url'),
            data: {
                typeId: $(this).data('id'),
            },
        });

        // hide dropdown menu
        notificationsSwitch.dropdown('toggle');

        return false;
    });
};
